import { useAuth as useAuthContext, type UserProfile } from "../context/AuthContext";

type Role = "super_admin" | "admin" | "manager" | "staff" | "cashier" | null;

interface UseAuthReturn {
  user: UserProfile | null;
  role: Role;
  idToken: string | null;
  isLoading: boolean;
}

/**
 * Convenience hook that wraps AuthContext and exposes auth state.
 * Use this in components instead of importing AuthContext directly.
 */
export function useAuth(): UseAuthReturn {
  const { user, role, idToken, isLoading } = useAuthContext();
  return { user, role, idToken, isLoading };
}
